import React, {useEffect, useState} from "react"
import {Select, Space} from "antd"
import {useClubMemberContext} from "../store/useClubMemberContext"
import Search from "antd/lib/input/Search"

const ClubMemberSearch = () => {

    const {onSearchKeyChange, searchKey, fetchClubMemberList, discountList, fetchDiscountList} = useClubMemberContext()

    const options = [
        {
            label: '电话',
            value: 1,
        },
        {
            label: '昵称',
            value: 2,
        },
        {
            label: '用户',
            value: 3,
        },

    ]


    const [inputValue, setInputValue] = useState('')


    //节流
    useEffect(() => {
        const timer = setTimeout(() => {
            onSearchKeyChange(inputValue, null, null)
        }, 500)

        return () => {
            clearTimeout(timer)
        }
    }, [inputValue])


    return (
        <div>
            <Space direction={"horizontal"}>
                <Space direction={"horizontal"} align={"center"}>
                    按条件搜索：
                    <Search
                        addonBefore={<Select
                            options={options}
                            onChange={(value) => onSearchKeyChange(null, value, null)}
                            value={searchKey.keywordType}
                        />}
                        onChange={(value) => {
                            setInputValue(value.target.value)
                        }}
                        onSearch={() => {
                            fetchClubMemberList(1)
                        }}
                        style={{width: 300}}
                        placeholder={"按条件搜索"}
                    />
                </Space>
                <Space direction={"horizontal"} align={"center"}>
                    按等级搜索：
                    <Select
                        options={discountList}
                        placeholder={"按等级搜索"}
                        style={{width: 200}}
                        onChange={(value) => {
                            onSearchKeyChange(null, null, value)

                        }}
                        allowClear

                    />
                </Space>
            </Space>
        </div>
    )
}

export default ClubMemberSearch


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberSearch.js